import { useEffect, useRef, useState } from "react";

/** Nextjs */

/** MUI */
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
/** - icons */

/** Helpers */
import uniqBy from "lodash/uniqBy";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

/** UI */
import AddLevels from "./components/AddLevels";
import Board from "./components/Board";

const useStyles = makeStyles((theme) => ({
    gridItemCell: {
        width: "calc((100% - 64px) / 3)",
        flexGrow: 1,
        display: "flex",
        alignItems: "center",
        "& b": {
            fontWeight: "bolder",
            paddingLeft: theme.spacing(0.5),
        },
    },
    gridItemCellCheck: {
        width: 64,
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            maxWidth: 44,
        },
    },
    gridItemCellColumn: {
        opacity: 1,
    },
    gridItemCellOrder: {
        [theme.breakpoints.down("lg")]: {
            maxWidth: 84,
            flexWrap: "wrap",
            position: "relative",
        },
    },
    button: {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        height: 51,
        [theme.breakpoints.down("lg")]: {
            minWidth: "unset",
            width: 48,
            height: 48,
            padding: 0,
        },
    },
    buttonStartIcon: {
        [theme.breakpoints.down("lg")]: {
            margin: 0,
            "& > *:nth-of-type(1)": {
                fontSize: 24,
            },
        },
    },
    notification: {
        position: "absolute",
        width: 1,
        height: 1,
        overflow: "hidden",
    },
}));

const TableSortingSettingDnD = (props) => {
    const { headData, layout, options, onChangeSorting, sorting } = props;

    if (!layout || !options || !sorting) return null;

    const classes = useStyles();
    const { t } = useTranslation();
    const notificationRef = useRef();

    /** States */
    const [LEVELS, setLEVELS] = useState(sorting || []);
    const [CHOISE, setCHOISE] = useState([]);
    const [CHOISES, setCHOISES] = useState([]);
    /** /end States */

    /** Effects */
    /** - set  CHOISE*/
    useEffect(() => {
        if (JSON.stringify(sorting) !== JSON.stringify(LEVELS)) {
            onChangeSorting(LEVELS);
        }

        let _headDataRows = headData?.rows || [];

        if (options?.showSymbols) {
            let _newIdx = 0;
            let _newHeadDataRows = [];
            _headDataRows?.forEach((row) => {
                _newHeadDataRows.push({ ...row, idx: _newIdx });
                if (row.type === "POS" || row.type === "JT") {
                    _newIdx++;
                    _newHeadDataRows.push({
                        ...row,
                        idx: _newIdx,
                        title: `${row.title} (${t("Symbol")})`,
                        title_orig: `${row.title_orig} (${t("Symbol")})`,
                        isSymbol: true,
                        disabled: LEVELS.map((l) => l.idx).includes(_newIdx - 1),
                    });
                }
                _newIdx++;
            });

            _headDataRows = _newHeadDataRows;
        }

        const _fullChoiseFromRows = _headDataRows?.map((r) => {
            const id = uuidv4();
            return {
                id,
                idx: r.idx,
                title: r.title,
                title_orig: r.title_orig,
                type: r.type,
                sort: "vertical",
                isSymbol: r.isSymbol,
                disabled: r.disabled,
            };
        });
        const _choiseFromRows = _fullChoiseFromRows.filter((r) => !LEVELS.map((l) => l.idx).includes(r.idx));

        const _fullChoiseFromCols = headData?.cols?.map((c) => {
            const id = uuidv4();
            return {
                id,
                idx: c?.idx,
                title: c?.title,
                title_orig: c?.title_orig,
                type: c?.type,
                sort: "horizontal",
                isSymbol: c.isSymbol,
                disabled: c.disabled,
            };
        });
        const _choiseFromCols = _fullChoiseFromCols.filter((c) => !LEVELS.map((l) => l.idx).includes(c?.idx));

        const _fullChoiseFromColsTitles = headData?.cols?.flatMap((c, ci) => {
            return ci === headData?.cols?.length - 1
                ? c?.titles.map((t, ti) => {
                      const id = uuidv4();
                      const title_orig = c?.titles_orig?.[ti];
                      return {
                          id,
                          idx: _headDataRows?.length + ti,
                          title: t,
                          title_orig,
                          type: c.type,
                          sort: "vertical",
                          isSymbol: c.isSymbol,
                          disabled: c.disabled,
                      };
                  })
                : [];
        });

        const _choiseFromColsTitles = _fullChoiseFromColsTitles.filter(
            (c) => !LEVELS.map((l) => l.idx).includes(c?.idx)
        );

        // setCHOISE([..._choiseFromRows, ..._choiseFromCols, ..._choiseFromColsTitles]);
        setCHOISE([..._choiseFromRows, ..._choiseFromColsTitles]);
        setCHOISES([..._fullChoiseFromRows, ..._fullChoiseFromColsTitles]);
    }, [LEVELS, headData, options]);

    /** - set LEVELS */
    useEffect(() => {
        let _headDataRows = headData?.rows || [];

        if (options?.showSymbols) {
            let _newIdx = 0;
            let _newHeadDataRows = [];
            _headDataRows?.forEach((row) => {
                _newHeadDataRows.push({
                    ...row,
                    idx: _newIdx,
                });
                if (row.type === "POS" || row.type === "JT") {
                    _newIdx++;
                    _newHeadDataRows.push({
                        ...row,
                        idx: _newIdx,
                        title: `${row.title} (${t("Symbol")})`,
                        isSymbol: true,
                    });
                }
                _newIdx++;
            });

            _headDataRows = _newHeadDataRows;
        }

        const _newLevelsFromRows = _headDataRows
            ?.map((r) => {
                return {
                    idx: r.idx,
                    title: r.title,
                    type: r.type,
                    ...(sorting.find((s) => s.idx === r.idx) || {}),
                };
            })
            .filter((r) => sorting.map((l) => l.idx).includes(r.idx));

        const _newLevelsFromCols = headData?.cols
            ?.map((c) => ({
                idx: c?.idx,
                title: c?.title,
                type: c?.type,
                ...(sorting.find((s) => s.idx === c.idx) || {}),
            }))
            .filter((c) => sorting.map((l) => l.idx).includes(c.idx));

        const _newLevelsFromColsTitles = headData?.cols
            ?.flatMap((c, ci) => {
                return ci === headData?.cols?.length - 1
                    ? c?.titles.map((t, ti) => {
                          const _idx = headData?.rows?.length + ti;
                          return {
                              idx: _idx,
                              title: t,
                              type: c.type,
                              ...(sorting.find((s) => s.idx === _idx) || {}),
                          };
                      })
                    : [];
            })
            .filter((c) => sorting.map((l) => l.idx).includes(c?.idx));

        const _newLevels = uniqBy(
            [..._newLevelsFromRows, ..._newLevelsFromCols, ..._newLevelsFromColsTitles].filter(
                (l) => options?.showSymbols || !l.isSymbol
            ),
            "id"
        );

        setLEVELS(_newLevels);
    }, [headData, options]);

    /** - reset LEVELS */
    useEffect(() => {
        setLEVELS(sorting);
        return () => {
            setLEVELS(sorting);
        };
    }, [sorting]);

    /** /end Effects */

    /** Handlers */
    const handleAddLevel = () => {
        const _addLevel = {
            active: false,
            ...CHOISE[0],
            order: "asc",
            place: LEVELS.length,
        };

        if (notificationRef?.current) {
            notificationRef.current.innerHTML = t(
                `Dodano poziom {{levelName}} z rosnącym sortowaniem na pozycji {{pos}} z {{size}}`,
                {
                    levelName: _addLevel?.title,
                    pos: LEVELS.length + 1,
                    size: LEVELS.length + 1,
                }
            );
        }

        const _newLevels = [...LEVELS, _addLevel];

        setLEVELS(_newLevels);
    };

    const handleOnUpdateLevels = (newLevels) => {
        setLEVELS(newLevels);
    };

    const handleOnRemoveLevel = ({ id }) => {
        const _newLevels = LEVELS?.filter((l) => l.id !== id);
        setLEVELS(_newLevels);
    };

    const handleOnChangeColumn = ({ column, id }) => {
        let newLevels = JSON.parse(JSON.stringify(LEVELS));

        const levelIndex = newLevels.findIndex((l) => l.id === id);

        if (levelIndex > -1) {
            newLevels[levelIndex] = { ...newLevels[levelIndex], ...column };

            if (!column?.isSymbol) {
                newLevels = newLevels?.filter((l) => !l.title?.includes(column?.title + " ("));
            }

            setLEVELS(newLevels);
        }
    };

    const handleReorderLevels = (newLevels) => {
        if (JSON.stringify(LEVELS) !== JSON.stringify(newLevels)) {
            setLEVELS(newLevels);
        }
    };

    const handleOnChangeOrder = ({ order, id }) => {
        let newLevels = JSON.parse(JSON.stringify(LEVELS));
        const levelIndex = newLevels.findIndex((l) => l.id === id);

        if (levelIndex > -1) {
            newLevels[levelIndex].order = order;
            setLEVELS(newLevels);
        }
    };
    /** /end Handlers */
    return (
        <>
            {!!LEVELS.length ? (
                <Grid container spacing={0} sx={{ mt: 1, mb: 3 }}>
                    <Grid item xs={12} sx={{ alignItems: "center", justifyContent: "flex-start", display: "flex" }}>
                        <AddLevels
                            onAddLevel={handleAddLevel}
                            onUpdateLevels={(newLevels) => handleOnUpdateLevels(newLevels)}
                            levels={LEVELS}
                            choises={CHOISES}
                        />
                    </Grid>
                </Grid>
            ) : null}

            <Board
                levels={LEVELS}
                choise={CHOISE}
                onAddLevel={handleAddLevel}
                onChangeColumn={({ column, id }) => handleOnChangeColumn({ column, id })}
                onChangeOrder={({ order, id }) => handleOnChangeOrder({ order, id })}
                onReorderLevels={(newLevels) => handleReorderLevels(newLevels)}
                onRemoveLevel={({ id }) => handleOnRemoveLevel({ id })}
            />

            <Box
                ref={notificationRef}
                aria-live="assertive"
                id={"add-level-notification"}
                className={classes.notification}
            ></Box>
        </>
    );
};
export default TableSortingSettingDnD;
